import { MdSave } from "react-icons/md";
import { useCallback, useEffect, useState } from "react";
//
import {
    useGetMandatoryFieldsMutation,
    useUpdateMandatoryFieldsMutation,
} from "../../../features/tenant/mandatoryFields/mandatoryFieldsApi";
import { Switch } from "../../../components/Switch";
import LinksComponent from "../../../components/Tenant/LinksComponent/LinksComponent";
import { useGetAppUserTypeQuery } from "../../../features/tenant/appUserType/appUserTypeApi";
import { useGetFormTemplateMutation } from "../../../features/tenant/formTemplate/formTemplateApi";

const MandatoryFieldsView = () => {
    const [selectedData, setSelectedData] = useState({});
    const [fieldsData, setFieldsData] = useState({});
    const [fetching, setFetching] = useState(true);

    let token = sessionStorage.getItem("access_token");
    let tenant_id = JSON.parse(sessionStorage.getItem("vendorData"))?.tenant_id;
    let form_type = 6; // Profile type

    const {
        data,
        isLoading: getAppUserTypeLoading,
        isError,
    } = useGetAppUserTypeQuery({
        token: token,
        tenant_id: tenant_id,
    });

    const [
        getMandatoryFields,
        { isLoading: mandatoryFieldsLoading, data: mandatoryFieldsData },
    ] = useGetMandatoryFieldsMutation({});

    const [getFormTemplate] = useGetFormTemplateMutation();

    const loading = fetching || getAppUserTypeLoading;

    const fetchAllFields = useCallback(async () => {
        let result = {};
        let user_types = {};

        setFetching(true);

        await Promise.all(
            data?.body?.map(async (item) => {
                try {
                    if (item?.user_type) {
                        const response = await getFormTemplate({
                            token: token,
                            form_type: form_type,
                            user_type: item?.user_type,
                            tenant_id: tenant_id,
                        });

                        const fieldResponse = await getMandatoryFields({
                            token: token,
                            tenant_id: tenant_id,
                            user_type: item?.user_type_id,
                        }).unwrap();

                        if (
                            !Array.isArray(response?.data?.body) &&
                            !!response?.data?.body
                        ) {
                            result[item?.user_type] = {
                                ...response?.data?.body,
                                user_type_id: item?.user_type_id,
                            };

                            user_types[item?.user_type_id] = {
                                fields:
                                    Object.keys(
                                        fieldResponse?.body?.fields || {}
                                    )?.length > 0
                                        ? fieldResponse?.body?.fields
                                        : {},

                                points:
                                    Object.keys(
                                        fieldResponse?.body?.points || {}
                                    )?.length > 0
                                        ? fieldResponse?.body?.points
                                        : {},

                                status:
                                    fieldResponse?.body?.status === "1"
                                        ? true
                                        : false,

                                combined:
                                    fieldResponse?.body?.combined === "1"
                                        ? true
                                        : false,
                                modified: false,
                            };
                        }
                    }
                } catch (error) {
                    console.log("ERROR\n", error);
                }
            })
        );

        const sortedResult = Object.fromEntries(
            Object.entries(result).sort(([a], [b]) => a.localeCompare(b))
        );

        setSelectedData(user_types);
        setFieldsData(sortedResult);

        setFetching(false);
    }, [data?.body]);

    const handleCheckboxChange = (action = "", value = {}) => {
        const { type, field, points, active, status, combined, modified } =
            value || {};

        switch (action) {
            case "field":
                setSelectedData((prev) => {
                    const currentTypeMap = prev?.[type] || {};
                    const nextTypeMap = { ...currentTypeMap?.fields };

                    // Points Data
                    const currentPointsData =
                        { ...currentTypeMap?.points } || {};

                    if (active) {
                        nextTypeMap[field?.name] = field;
                    } else {
                        delete nextTypeMap?.[field?.name];
                        delete currentPointsData?.[field?.name];
                    }

                    return {
                        ...prev,
                        [type]: {
                            ...currentTypeMap,
                            fields: nextTypeMap,
                            points: currentPointsData,
                            modified: true,
                        },
                    };
                });

                break;

            case "points":
                setSelectedData((prev) => {
                    const currentTypeMap = prev?.[type] || {};
                    const nextTypeMap = { ...currentTypeMap?.points };

                    if (
                        points !== 0 &&
                        Math.sign(points) === 1 &&
                        !isNaN(points)
                    ) {
                        nextTypeMap[field?.name] = Number(points);
                    } else {
                        delete nextTypeMap[field?.name];
                    }

                    return {
                        ...prev,
                        [type]: {
                            ...currentTypeMap,
                            points: nextTypeMap,
                            modified: true,
                        },
                    };
                });

                break;

            case "status":
                setSelectedData((prev) => {
                    const currentTypeMap = prev?.[type] || {};

                    return {
                        ...prev,
                        [type]: {
                            ...currentTypeMap,
                            status: status,
                            modified: true,
                        },
                    };
                });

                break;

            case "combined":
                setSelectedData((prev) => {
                    const currentTypeMap = prev?.[type] || {};

                    return {
                        ...prev,
                        [type]: {
                            ...currentTypeMap,
                            combined: combined,
                            modified: true,
                        },
                    };
                });

                break;

            case "modify":
                setSelectedData((prev) => {
                    const currentTypeMap = prev?.[type] || {};

                    return {
                        ...prev,
                        [type]: {
                            ...currentTypeMap,
                            modified: modified,
                        },
                    };
                });
        }
    };

    useEffect(() => {
        if (!!data?.body?.length) {
            fetchAllFields();
        }
    }, [data]);

    return (
        <section className="w-full bg-white h-full  flex flex-col justify-stretch items-stretch overflow-hidden">
            <div className="border-b bg-white border-gray-300 pl-6 py-2 shadow-sm text-xl font-bold overflow-hidden">
                Mandatory Profile Fields
                <LinksComponent />
            </div>

            <div
                className="w-full flex flex-row flex-grow-1 flex-shrink-0 gap-4 px-4 py-2 overflow-x-auto rounded transition-all"
                style={{
                    ...(loading && {
                        opacity: 0.7,
                        pointerEvents: "none",
                    }),
                }}
            >
                {!loading &&
                    Object.entries(fieldsData)?.map((item, index) => (
                        <RenderFields
                            key={index}
                            item={item}
                            token={token}
                            tenant_id={tenant_id}
                            selectedData={selectedData}
                            handleCheckboxChange={handleCheckboxChange}
                        />
                    ))}
            </div>
        </section>
    );
};

const RenderFields = ({
    item,
    token,
    tenant_id,
    selectedData,
    handleCheckboxChange,
}) => {
    const fieldName = item?.[0];
    const fieldValue = item?.[1];
    const formTemplate = fieldValue?.template;

    const currentData = selectedData?.[fieldValue?.user_type_id] || {};

    const status = currentData?.status;
    const isCombined = currentData?.combined;
    const isModified = currentData?.modified;

    const [updateMandatoryFields, { data, isLoading, error }] =
        useUpdateMandatoryFieldsMutation();

    const handleSave = async () => {
        updateMandatoryFields({
            body: {
                fields: currentData?.fields || {},
                points: currentData?.points || {},
                user_type: fieldValue?.user_type_id,
                form_template_id: fieldValue?.form_template_id,
                status: currentData?.status ? "1" : "2",
                combined: currentData?.combined ? "1" : "2",
            },
            tenant_id: tenant_id,
            token: token,
        });
        handleCheckboxChange("modify", { modified: false });
    };

    const primaryColor = JSON.parse(sessionStorage.getItem("vendorTheme"))
        ?.theme?.color_shades;

    if (!!fieldName || !!formTemplate) {
        return (
            <div
                className="border flex !border-gray-400 bg-white min-w-[360px] max-w-[360px] max-h-[80dvh] flex-col justify-between items-stretch rounded-md overflow-hidden"
                style={{
                    ...(!!isLoading && {
                        opacity: 0.7,
                        pointerEvents: "none",
                    }),
                }}
            >
                <div className="w-full flex flex-col overflow-y-auto">
                    <div className="w-full sticky top-0 border-b border-gray-400 py-2 px-3 bg-gray-200 flex flex-row items-center justify-between">
                        <div className="flex flex-col justify-start items-start">
                            <h4 className="text-xl uppercase font-medium">
                                {fieldValue?.user_type}
                            </h4>
                            <span className="text-sm text-black/50">
                                {fieldValue?.form_template_name}
                            </span>
                        </div>

                        <div className="flex flex-row gap-1 items-center justify-center">
                            <span className="text-sm">
                                {status ? "Active" : "Inactive"}
                            </span>

                            <input
                                type="checkbox"
                                checked={status}
                                onChange={() =>
                                    handleCheckboxChange("status", {
                                        type: fieldValue?.user_type_id,
                                        status: !status,
                                    })
                                }
                            />
                        </div>
                    </div>

                    <div className="flex px-3 py-3 flex-col gap-2 overflow-y-auto justify-start items-start w-full">
                        {Object.values(formTemplate)?.map(
                            (field, fieldIndex) => {
                                const selectedForType =
                                    currentData?.fields || {};
                                const isActive =
                                    !!selectedForType?.[field?.name];

                                const currentPoints =
                                    currentData?.points?.[field?.name] || "";

                                return (
                                    <div
                                        key={fieldIndex}
                                        className="w-full flex flex-col gap-4"
                                    >
                                        {fieldIndex !== 0 && (
                                            <span className="h-[1px] w-full bg-black/10" />
                                        )}

                                        <div className="flex flex-row items-center justify-between gap-2">
                                            <div className="flex flex-row gap-2 items-center justify-start">
                                                <input
                                                    id={field?.name}
                                                    type="checkbox"
                                                    checked={isActive}
                                                    onChange={() =>
                                                        handleCheckboxChange(
                                                            "field",
                                                            {
                                                                type: fieldValue?.user_type_id,
                                                                field: field,
                                                                active: !isActive,
                                                            }
                                                        )
                                                    }
                                                />

                                                <span className="text-md text-black">
                                                    {field?.label}
                                                </span>
                                            </div>

                                            <div
                                                className="flex flex-row items-center justify-end transition-all duration-100"
                                                style={{
                                                    ...(!isActive && {
                                                        pointerEvents: "none",
                                                        opacity: 0,
                                                    }),
                                                }}
                                            >
                                                <input
                                                    min={0}
                                                    type="number"
                                                    placeholder="Points"
                                                    value={currentPoints}
                                                    disabled={!isActive}
                                                    className="w-[100px] pl-2 py-1 rounded border border-gray-300 hover:!border-gray-400 focus:!border-gray-500 transition-colors"
                                                    onChange={(event) =>
                                                        isActive &&
                                                        handleCheckboxChange(
                                                            "points",
                                                            {
                                                                type: fieldValue?.user_type_id,
                                                                field: field,
                                                                points: event
                                                                    .target
                                                                    .value,
                                                            }
                                                        )
                                                    }
                                                />
                                            </div>
                                        </div>
                                    </div>
                                );
                            }
                        )}
                    </div>
                </div>

                <div className="sticky bottom-0 flex px-3 border-t border-gray-400 bg-gray-200 flex-row py-2 justify-center items-center">
                    <div className="flex flex-col items-start justify-start w-full">
                        <span>Reward points</span>
                        <Switch
                            checked={isCombined}
                            onChange={() =>
                                handleCheckboxChange("combined", {
                                    type: fieldValue?.user_type_id,
                                    combined: !isCombined,
                                })
                            }
                            label={isCombined ? "Combined" : "Individual"}
                        />
                    </div>

                    <button
                        className="uppercase rounded border-none outline-none px-4 py-2 flex flex-row items-center justify-center gap-1 disabled:opacity-50 disabled:saturate-0"
                        style={{
                            background: primaryColor[700],
                            color: primaryColor[50],
                        }}
                        disabled={!isModified}
                        onClick={handleSave}
                    >
                        <MdSave /> {isLoading ? "Saving..." : "Save"}
                    </button>
                </div>
            </div>
        );
    }
};

export default MandatoryFieldsView;
